<template>
    <v-badge
        v-if="record.output"
        color="black"
        class="ml-2"
        :content="content"
        inline
    >
    </v-badge>
</template>
<script setup>
import { computed } from 'vue'
const props = defineProps(['record', 'count'])
const content = computed(() => (props.count ? props.count : '0'))
</script>
